/**
 * @graph-stack product-innovation-lab
 * @graph-domain Operations
 * @graph-business ops ダッシュボードの取得失敗（再試行ボタンつき）・集計中の表示。SLO タブ全体と内訳タブの各カードが同じ見た目・文言を使う
 * @graph-connects none
 */
import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@cortex/web-design-system/components/ui/Button';

/** OpsFetchErrorPanel の props。 */
export interface OpsFetchErrorPanelProps {
  /** 再取得する。 */
  onRetry: () => void;
}

/** 集計データの取得失敗と再試行ボタン。 @graph-connects none */
export function OpsFetchErrorPanel({ onRetry }: OpsFetchErrorPanelProps): ReactNode {
  const { t } = useTranslation();
  return (
    <div className="flex flex-col items-center gap-3 py-6 text-center">
      <p className="text-sm text-[var(--color-text-secondary)]">{t('ops.dashboard.fetchError')}</p>
      <Button variant="secondary" size="sm" onClick={onRetry}>
        {t('ops.common.retry')}
      </Button>
    </div>
  );
}

/** 集計中の表示。 @graph-connects none */
export function OpsAggregatingPanel(): ReactNode {
  const { t } = useTranslation();
  return (
    <div className="py-8 text-center text-sm text-[var(--color-text-muted)]">
      {t('ops.dashboard.aggregating')}
    </div>
  );
}
